var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$user.primeiroAcesso)?_c('div',[_c('transition',{attrs:{"mode":"out-in"}},[_c('Filiacao')],1)],1):_c('div',[_c('TheHeader'),_c('transition',{attrs:{"mode":"out-in"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }